const initialState = ['FIRST_SHIPMENT'];
const initialStateForTest = ['FIRST_SHIPMENT'];

export default initialState;
export { initialStateForTest };
